import React from "react";
import GridContainer from "common/components/Grid/GridContainer.jsx";
import GridItem from "common/components/Grid/GridItem.jsx";
import loadContent from "core-module/hoc/loadContent";

import LoadingBox from "common/components/LoadingBox";

import PhoneByBillingpackage from "./PhoneByBillingpackage.jsx";
import BillingPackageSelectCard from "./BillingPackageSelectCard.jsx";
import NoPhoneAccount from "./NoPhoneAccount.jsx";

import PhoneBasicSettingsWizard from "./BasicSettingsWizard.jsx";
import VoicemailSettingsWizard from "./VoicemailSettingsWizard.jsx";

class Phone extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedBillingPackage: 0,
      selectedEmergencyProfile: 0,
      voipBpsId: 0,
      associatedDnList: [],
      wizard: null,
      loading: false
    };

    this.billingpackageList = this.props.getList((oGet, id) => id);
    this.emergencyprofileType = {};
    this.props.getList((oGet, id) => {
      this.emergencyprofileType[id] = oGet("emergencyprofile_type");
    });
  }

  //Wizard/Screen Rendering control

  handleSelectBillingPackage = event => {
    this.setState({ selectedBillingPackage: event.target.value });
  };

  closeWizard = () => this.setState({ wizard: null });

  selectBasicSettingsWizard = voipBpsId => {
    this.setState({
      wizard: "basicsettings",
      voipBpsId: voipBpsId
    });
  };

  selectVoicemailWizard = voipBpsId => {
    this.setState({
      wizard: "voicemail",
      voipBpsId: voipBpsId
    });
  };

  render() {
    if (this.state.loading) {
      return <LoadingBox />;
    }

    if (
      this.billingpackageList == null ||
      this.billingpackageList.length === 0
    ) {
      return (
        <GridContainer justify="center">
          <GridItem key="noVoip" xs={12}>
            <NoPhoneAccount />
          </GridItem>
        </GridContainer>
      );
    }

    const bpid = this.billingpackageList[this.state.selectedBillingPackage];

    if (this.state.wizard === "basicsettings") {
      return (
        <PhoneBasicSettingsWizard
          onFinishBasicSettingsWizard={this.onFinishBasicSettingsWizard}
          closeWizard={this.closeWizard}
          pathids={{
            billingpackage: bpid,
            voipfeatures: this.state.voipBpsId
          }}
        />
      );
    }

    if (this.state.wizard === "voicemail") {
      return (
        <VoicemailSettingsWizard
          onFinishVoicemailWizard={this.onFinishVoicemailWizard}
          closeWizard={this.closeWizard}
          pathids={{
            billingpackage: bpid,
            voipfeatures: this.state.voipBpsId
          }}
        />
      );
    }

    return (
      <GridContainer justify="center">
        {this.billingpackageList.length === 1 ? null : (
          <GridItem key="selectbpid" xs={12}>
            <BillingPackageSelectCard
              selectedBillingPackage={this.state.selectedBillingPackage}
              handleSelect={this.handleSelectBillingPackage}
              billingpackageList={this.billingpackageList}
            />
          </GridItem>
        )}
        <GridItem xs={12}>
          <PhoneByBillingpackage
            pathids={{
              billingpackage: bpid
            }}
            onClickEditBasicSettings={this.selectBasicSettingsWizard}
            onClickEditVoicemailSettings={this.selectVoicemailWizard}
            shouldRender="BasicSettings"
          />
        </GridItem>
      </GridContainer>
    );
  }
}

export default loadContent("user.session/billingpackage_voip", Phone);
